import React from 'react';
import View from './view.js';
import useField from 'Data/useField.js';

export default function Logic(props) {
  let field = useField('PatientFirstName');

  return <View {...field} />;
}
